<div class="vocabulary-detail-container">
    <div class="card card-block">
        <div class="form-group row">
            <div class="col-md-12">
                <div class="card-text"> {{vocabularyInfo.word}}</div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12">
                <div *ngIf="vocabularyInfo.definitionOptions.length"
                     class="form-label"> {{vocabularyInfo.definitionOptions[0].definition}}
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12">
                <div *ngIf="vocabularyInfo.definitionOptions.length && vocabularyInfo.definitionOptions[0].translationOptions.length"
                     class="form-label indent"> {{vocabularyInfo.definitionOptions[0].translationOptions[0].word}}</div>
            </div>

        </div>

        <div class="form-group row">
            <div class="btn-group-sm col-md-12">
                <button class="btn btn-outline-primary btn-sm" [disabled]="changeDisabled()"
                        (click)="replaceVocabularyEntry()">Replace
                </button>
                <button class="btn btn-outline-primary btn-sm" [disabled]="changeDisabled()"
                        (click)="deleteVocabularyEntry()">Delete
                </button>
            </div>
        </div>
    </div>
</div>
